import Head from 'next/head';
import { WebsiteSchema } from '@/components/homepage/WebsiteSchema';
import TradeInHero from '@/components/tradein/Hero';
import TradeInSubhero from '@/components/tradein/Subhero';
import TradeIn from '@/components/tradein/TradeIn';
import TradeInSteps from '@/components/tradein/Steps';
import TradeInFaqs from '@/components/tradein/Faqs';
import FeaturedClient from '@/components/homepage/FeaturedClient';
import { REDIRECT_HOME } from '@/lib/common';
import { getShortenCountryName } from '@/lib/use-origin-country';
import i18n from '@/settings/i18n';
import { isTradeInAvailable } from '@/lib/trade-in';

const t = i18n.init('buyback');

export const getServerSideProps = () => {
  if (!isTradeInAvailable()) {
    return REDIRECT_HOME;
  }

  return { props: {} };
};

const TradeInPage = () => (
  <div className="bg-[#F2F2F2]">
    <WebsiteSchema
      title={t`Trade In Your Tech For Cash | Reebelo ${{
        country: getShortenCountryName(),
      }}`}
      description={t`Turn old tech into cash with Reebelo. Get an instant offer for your iPhone, laptop, tablet & more. Free shipping, fast payouts, and eco-friendly.`}
    />
    <Head>
      {/* Stop the page from automatically zooming in on mobile when interacting with input fields */}
      <meta
        name="viewport"
        content="width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no"
      />
    </Head>
    <TradeInHero />
    <TradeInSubhero />
    <TradeIn />
    <TradeInSteps />
    <TradeInFaqs />
    <div className="border-t bg-white py-6 xxs:py-8 md:py-10">
      <div className="reebelo-container">
        <FeaturedClient />
      </div>
    </div>
  </div>
);

export default TradeInPage;
